import i18next from "i18next";
import * as React from "react";
import { ParamType } from "../../api/GrammarApi";

export type OnParamSelectProp = (paramCode: string, value: string) => void;

type ParamTypeSelectorProps = {
  paramType: ParamType;
  onSelect: OnParamSelectProp;
  value?: string;
};

function ParamTypeSelector({ paramType, onSelect, value }: ParamTypeSelectorProps) {
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      onSelect(paramType.code, e.target.value);
    },
    [onSelect, paramType.code]
  );

  return (
    <div className="marker-menu-paramtype-selector">
      <label htmlFor={paramType.code} className="marker-menu-paramtype-selector-label">
        {paramType.label}{" "}
        {paramType.required && (
          <span className="required" title={i18next.t("global.required")}>
            *
          </span>
        )}
      </label>
      <select
        id={paramType.code}
        value={value || paramType.defaultOpt || ""}
        onChange={handleChange}
        required={paramType.required}
        autoComplete="on"
      >
        {!paramType.defaultOpt && !value && <option></option>}
        {paramType.options.map((option) => (
          <option key={option.code} value={option.code}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default ParamTypeSelector;
